"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.locales = exports.ordered = exports.DEFAULT_LOCALE_CODE = exports.chineseTraditional = exports.chineseSimplified = exports.vietnamese = exports.thai = exports.tagalog = exports.russian = exports.portuguese = exports.malay = exports.indonesian = exports.lao = exports.korean = exports.japanese = exports.french = exports.english = exports.italian = exports.spanish = exports.german = exports.arabic = void 0;
/**
 * Locale Constants
 * @typedef {Object} Locale
 * @property {string} code should be a ISO locale code
 * @property {string} label a localised name for the language, ie japanese should be "日本語"
 * @property {string} loadingText a localised string to display when something is loading
 * ie japanese should be "読み込み中・・・"
 * @property {string} [dir] the direction of the text either "ltr" (assumed default) or "rtl"
 * @property {string} [facebook] code used for integrating with facebook apis
 * @property {string} [moment] code used to load moment locale files
 * @property {string} [postCodePrefix] used to prefix the post code (mostly japanese)
 */

/**
 * @type {Locale} code: 'ar'
 */

var arabic = {
  code: 'ar',
  facebook: 'ar_AR',
  label: 'عربى',
  loadingText: 'جار التحميل...',
  dir: 'rtl',
  translations: {
    ar: 'العربية',
    de: 'الألمانية',
    en: 'الإنجليزية',
    es: 'الإسبانية',
    fr: 'الفرنسية',
    id: 'الإندونيسية',
    it: 'الإبطالية',
    ja: 'اليابانية',
    ko: 'الكورية',
    lo: 'اللاوسية',
    ms: 'الملايو',
    pt: 'البرتغالية',
    ru: 'الروسية',
    th: 'التايلاندية',
    tl: 'الفلبينية',
    tr: 'التركية',
    vi: 'الفيتنامية',
    'zh-CN': 'الصينية (المبسيطة)',
    'zh-TW': 'الصينية (التقليدية)'
  }
};
/**
 * @type {Locale} code: 'de'
 */

exports.arabic = arabic;
var german = {
  code: 'de',
  facebook: 'de_DE',
  label: 'Deutsch',
  loadingText: 'Laden...',
  translations: {
    ar: 'Arabische',
    de: 'Deutsch',
    en: 'Englisch',
    es: 'Spanisch',
    fr: 'Französich',
    id: 'Indonesische',
    it: 'Italienisch',
    ja: 'Japanisch',
    ko: 'Koreanisch',
    lo: 'Laotische',
    ms: 'Malaiische',
    pt: 'Portugiesische',
    ru: 'Russisch',
    th: 'Thai',
    tl: 'Philippinische',
    tr: 'Türkische',
    vi: 'Vietnamesische',
    'zh-CN': '‪Chinesisch (Einf.)',
    'zh-TW': '‪Chinesisch (Trad.)'
  }
};
/**
 * @type {Locale} code: 'es'
 */

exports.german = german;
var spanish = {
  code: 'es',
  facebook: 'es_ES',
  label: 'Español',
  loadingText: 'Cargando...',
  translations: {
    ar: 'Árabe',
    de: 'Alemán',
    en: 'Inglés',
    es: 'Español',
    fr: 'Francés',
    id: 'Indonesio',
    it: 'Italiano',
    ja: 'Japonés',
    ko: 'Coreano',
    lo: 'Lao',
    ms: 'Malayo',
    pt: 'Portuguesa',
    ru: 'Ruso',
    th: 'Tailandés',
    tl: 'Filipina',
    tr: 'Turco',
    vi: 'Vietnamita',
    'zh-CN': 'Chino (Simp.)',
    'zh-TW': 'Chino (Trad.)'
  }
};
/**
 * @type {Locale} code: 'it'
 */

exports.spanish = spanish;
var italian = {
  code: 'it',
  facebook: 'it_IT',
  label: 'Italiano',
  loadingText: 'Caricamento in corso...',
  translations: {
    ar: 'Araba',
    de: 'Tedesco',
    en: 'English',
    es: 'Spagnolo',
    fr: 'French',
    id: 'Indonesiana',
    it: 'Italiano',
    ja: 'Japanese',
    ko: 'Korean',
    lo: 'Lao',
    ms: 'Malese',
    pt: 'Portoghese',
    ru: 'Russo',
    th: 'Tailandese',
    tl: 'Filippina',
    tr: 'Turca',
    vi: 'Vietnamita',
    'zh-CN': '‪Chinese (simp.)',
    'zh-TW': '‪Chinese (trad.)'
  }
};
/**
 * @type {Locale} code: 'en'
 */

exports.italian = italian;
var english = {
  code: 'en',
  facebook: 'en_US',
  label: 'English',
  loadingText: 'Loading...',
  translations: {
    ar: 'Arabic',
    de: 'German',
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    id: 'Indonesian',
    it: 'Italian',
    ja: 'Japanese',
    ko: 'Korean',
    lo: 'Lao',
    ms: 'Malay',
    pt: 'Portuguese',
    ru: 'Russian',
    th: 'Thai',
    tl: 'Filipino',
    tr: 'Turkish',
    vi: 'Vietnamese',
    'zh-CN': '‪Chinese (Simp.)',
    'zh-TW': '‪Chinese (Trad.)'
  }
};
/**
 * @type {Locale} code: 'fr'
 */

exports.english = english;
var french = {
  code: 'fr',
  facebook: 'fr_FR',
  label: 'Français',
  loadingText: 'Chargement...',
  translations: {
    ar: 'Arabe',
    de: 'Allemand',
    en: 'Anglais',
    es: 'Espagnol',
    fr: 'Français',
    id: 'Indonésienne',
    it: 'Italien',
    ja: 'Japonais',
    ko: 'Coréen',
    lo: 'Lao',
    ms: 'Malaise',
    pt: 'Portugaise',
    ru: 'Russe',
    th: 'Thai',
    tl: 'Philippine',
    tr: 'Turque',
    vi: 'Vietnamienne',
    'zh-CN': 'Chinois (Simp.)',
    'zh-TW': 'Chinois (Trad.)'
  }
};
/**
 * @type {Locale} code: 'ja'
 */

exports.french = french;
var japanese = {
  code: 'ja',
  facebook: 'ja_JP',
  label: '日本語',
  loadingText: '読み込み中・・・',
  postCodePrefix: '〒',
  translations: {
    ar: 'アラビア語',
    de: 'ドイツ語',
    en: '英語',
    es: 'スペイン語',
    fr: 'フランス語',
    id: 'インドネシア語',
    it: 'イタリア語',
    ja: '‪日本語‬',
    ko: '韓国語‬',
    lo: 'ラオ語',
    ms: 'マレー語',
    pt: 'ポルトガル語',
    ru: 'ロシア語',
    th: 'タイ語',
    tl: 'フィリピン語',
    tr: 'トルコ語',
    vi: 'ベトナム語',
    'zh-CN': '中国語(簡体)',
    'zh-TW': '中国語(繁体)'
  }
};
/**
 * @type {Locale} code: 'ko'
 */

exports.japanese = japanese;
var korean = {
  code: 'ko',
  facebook: 'ko_KR',
  label: '한국어',
  loadingText: '로딩 중...',
  translations: {
    ar: '아랍어',
    de: '독일어',
    en: '영어',
    es: '스페인어',
    fr: '프랑스어',
    id: '인도네시아어',
    it: '이탈리아어',
    ja: '일본어',
    ko: '한국어',
    lo: '라오어',
    ms: '말레이어',
    pt: '포르투갈어',
    ru: '러시아어',
    th: '태국어',
    tl: '필리핀어',
    tr: '터키어',
    vi: '베트남어',
    'zh-CN': '중국어 (간체)',
    'zh-TW': '중국어 (번체)'
  }
};
/**
 * @type {Locale} code: 'lo'
 */

exports.korean = korean;
var lao = {
  code: 'lo',
  facebook: 'lo_LA',
  label: 'ພາສາລາວ',
  loadingText: 'ກຳ ລັງໂຫລດ ...',
  translations: {
    ar: 'ພາສາອາຣາບິກ',
    de: 'ພາສາເຢຍລະມັນ',
    en: 'ພາສາອັງກິດ',
    es: 'ພາສາແອັສປາຍ',
    fr: 'ພາສາຝຣັ່ງ',
    id: 'ພາສາອິນໂດນີເຊຍ',
    it: 'ພາສາອີຕາລີ',
    ja: 'ພາສາຍີ່ປຸ່ນ',
    ko: 'ພາສາເກົາຫຼີ',
    lo: 'ພາສາລາວ',
    ms: 'ພາສາມາເລເຊຍ',
    pt: 'ພາສາປັອກຕຸຍການ',
    ru: 'ພາສາລັດເຊຍ',
    th: 'ພາສາໄທ',
    tl: 'ພາສາຟິລິບປິນ',
    tr: 'ພາສາຕວກກີ',
    vi: 'ພາສາຫວຽດນາມ',
    'zh-CN': '‪ພາສາຈີນ (ກາງ)‬',
    'zh-TW': '‪ພາສາຈີນ (ດັ້ງເດີມ)‬‬‬‬'
  }
};
/**
 * @type {Locale} code: 'id'
 */

exports.lao = lao;
var indonesian = {
  code: 'id',
  facebook: 'id_ID',
  label: 'Bahasa Indonesia',
  loadingText: 'Pemuatan...',
  translations: {
    ar: 'Bahasa Arab',
    de: 'Bahasa Jerman',
    en: 'Bahasa Inggris',
    es: 'Bahasa Spanyol',
    fr: 'Bahasa Perancis',
    id: 'Bahasa Indonesia',
    it: 'Bahasa Italia',
    ja: 'Bahasa Jepang',
    ko: 'Bahasa Korea',
    lo: 'Bahasa Lao',
    ms: 'Bahasa Melayu',
    pt: 'Bahasa Portugis',
    ru: 'Bahasa Rusia',
    th: 'Bahasa Thailand',
    tl: 'Bahasa Filipina',
    tr: 'Bahasa Turki',
    vi: 'Bahasa Vietnam',
    'zh-CN': 'Bahasa Cina (diseder.)',
    'zh-TW': 'Bahasa Cina (trad.)'
  }
};
/**
 * @type {Locale} code: 'ms'
 */

exports.indonesian = indonesian;
var malay = {
  code: 'ms',
  facebook: 'ms_MY',
  label: 'Bahasa Melayu',
  loadingText: 'Memuatkan...',
  translations: {
    ar: 'Bahasa Arab',
    de: 'Bahasa Jerman',
    en: 'Bahasa Inggeris',
    es: 'Bahasa Sepanyol',
    fr: 'Bahasa Perancis',
    id: 'Bahasa Indonesia',
    it: 'Bahasa Itali',
    ja: 'Bahasa Jepun',
    ko: 'Bahasa Korea',
    lo: 'Bahasa Lao',
    ms: 'Bahasa Melayu',
    pt: 'Bahasa Portugal',
    ru: 'Bahasa Rusia',
    th: 'Bahasa Thai',
    tl: 'Bahasa Filipina',
    tr: 'Bahasa Turki',
    vi: 'Bahasa Vietnam',
    'zh-CN': '‪Bahasa Cina (dimudah.)',
    'zh-TW': '‪Bahasa Cina (trad.)'
  }
};
/**
 * @type {Locale} code: 'pt'
 */

exports.malay = malay;
var portuguese = {
  code: 'pt',
  facebook: 'pt_PT',
  label: 'Português',
  loadingText: 'Carregandot...',
  translations: {
    ar: 'Árabe',
    de: 'Alemão',
    en: 'Inglês',
    es: 'Espanhol',
    fr: 'Francês',
    id: 'Indonésia',
    it: 'Italiano',
    ja: 'Japonês',
    ko: 'Coreano',
    lo: 'Lao',
    ms: 'Malaio',
    pt: 'Português',
    ru: 'Russo',
    th: 'Tailandês',
    tl: 'Filipina',
    tr: 'Turco',
    vi: 'Vietnamita',
    'zh-CN': '‪Chinês (Simp.)',
    'zh-TW': '‪Chinês (Trad.)'
  }
};
/**
 * @type {Locale} code: 'ru'
 */

exports.portuguese = portuguese;
var russian = {
  code: 'ru',
  facebook: 'ru_RU',
  label: 'Русский',
  loadingText: 'Загрузка...',
  translations: {
    ar: 'Арабский',
    de: 'Немецкий',
    en: 'Английский',
    es: 'Испанский',
    fr: 'Французский',
    id: 'Индонезийский',
    it: 'Итальянский',
    ja: 'Японский',
    ko: 'Корейский',
    lo: 'Лаосский',
    ms: 'Малайский',
    pt: 'Португальский',
    ru: 'Pусский',
    th: 'Тайский',
    tl: 'Филиппинский',
    tr: 'Турецкий',
    vi: 'Вьетнамский',
    'zh-CN': '‪Китайский (Упр.)‬',
    'zh-TW': '‪Китайский (Трад.)‬'
  }
};
/**
 * @type {Locale} code: 'tl'
 */

exports.russian = russian;
var tagalog = {
  code: 'tl',
  facebook: 'tl_PH',
  label: 'Tagalog',
  loadingText: 'Naglo-load...',
  moment: 'tl-ph',
  aliases: ['fil'],
  translations: {
    ar: 'Arabe',
    de: 'Aleman',
    en: 'Ingles',
    es: 'Espanyol',
    fr: 'Pranses',
    id: 'Indonesiyo',
    it: 'Italyano',
    ja: 'Hapones',
    ko: 'Koreano',
    lo: 'Lao',
    ms: 'Malay',
    pt: 'Portuges',
    ru: 'Ruso',
    th: 'Thai',
    tl: 'Tagalog',
    tr: 'Turko',
    vi: 'Vietnamese',
    'zh-CN': 'Tsino (Pinasimple)',
    'zh-TW': 'Tsino (Tradisyonal)'
  }
};
/**
 * @type {Locale} code: 'th'
 */

exports.tagalog = tagalog;
var thai = {
  code: 'th',
  facebook: 'th_TH',
  label: 'ไทย',
  loadingText: 'กำลังโหลด...',
  translations: {
    ar: 'ภาษาอารบิก',
    de: 'ภาษาเยอรมัน',
    en: 'ภาษาอังกฤษ',
    es: 'ภาษาสเปน',
    fr: 'ภาษาฝรั่งเศส',
    id: 'ภาษาอินโดนีเซีย',
    it: 'ภาษาอิตาเลียน',
    ja: 'ภาษาญี่ปุ่น',
    ko: 'ภาษาเกาหลี',
    lo: 'ภาษาลาว',
    ms: 'ภาษามาเลย์',
    pt: 'ภาษาโปรตุเกส',
    ru: 'รัสเซีย',
    th: 'ภาษาไทย',
    tl: 'ภาษาฟิลิปปินส์',
    tr: 'ภาษาตุรกี',
    vi: 'ภาษาเวียดนาม',
    'zh-CN': '‪ภาษาจีน (กลาง)‬',
    'zh-TW': '‪ภาษาจีน (ดั้งเดิม)‬‬‬‬'
  }
};
/**
 * @type {Locale} code: 'vi'
 */

exports.thai = thai;
var vietnamese = {
  code: 'vi',
  facebook: 'vi_VN',
  label: 'Tiếng việt',
  loadingText: 'Tải...',
  translations: {
    ar: 'Tiếng Ả rập',
    de: 'Tiếng Đức',
    en: 'Tiếng Anh',
    es: 'Tiếng Tây Ban Nha',
    fr: 'Tiếng Pháp',
    id: 'Tiếng Indonesia',
    it: 'Tiếng Ý',
    ja: 'Tiếng Nhật',
    ko: 'Tiếng Hàn',
    lo: 'Tiếng Lào',
    ms: 'Tiếng Malay',
    pt: 'Tiếng Bồ Đào Nha',
    ru: 'Tiếng Nga',
    th: 'Tiếng Thái Lan',
    tl: 'Tiếng Filipino',
    tr: 'Tiếng Thổ Nhĩ Kỳ',
    vi: 'Tiếng Việt',
    'zh-CN': '‪Tiếng Trung (Giản thể)‬‬‬',
    'zh-TW': 'Tiếng Trung (Phồn thể)‬'
  }
};
/**
 * @type {Locale} code: 'zh-CN'
 */

exports.vietnamese = vietnamese;
var chineseSimplified = {
  code: 'zh-CN',
  facebook: 'zh_CN',
  label: '简体中文',
  loadingText: '上传中・・・',
  aliases: ['zh', 'zh-Hans'],
  translations: {
    ar: '阿拉伯语',
    de: '德语',
    en: '英语',
    es: '西班牙语',
    fr: '法国语',
    id: '印度尼西亚语',
    it: '意大利语',
    ja: '日语',
    ko: '韩语',
    lo: '老挝语',
    ms: '马来语',
    pt: '葡萄牙语',
    ru: '俄语',
    th: '泰语',
    tl: '菲律宾语',
    tr: '土耳其语',
    vi: '越南语',
    'zh-CN': '‪简体中文‬',
    'zh-TW': '繁体中文'
  }
};
/**
 * @type {Locale} code: 'zh-TW'
 */

exports.chineseSimplified = chineseSimplified;
var chineseTraditional = {
  code: 'zh-TW',
  facebook: 'zh_TW',
  label: '繁体中文',
  loadingText: '讀取中・・・',
  aliases: ['zh-MO', 'zh-HK', 'zh-Hant'],
  translations: {
    ar: '阿拉伯語',
    de: '德語',
    en: '英語',
    es: '西班牙語',
    fr: '法國語',
    id: '印度尼西亞語',
    it: '意大利語',
    ja: '日語',
    ko: '韩語',
    lo: '老撾語',
    ms: '馬來語',
    pt: '葡萄牙語',
    ru: '俄語',
    th: '泰語',
    tl: '菲律賓語',
    tr: '土耳其語',
    vi: '越南語',
    'zh-CN': '‪簡體中文‬',
    'zh-TW': '繁體中文'
  }
};
/**
 * @private
 */

exports.chineseTraditional = chineseTraditional;
var DEFAULT_LOCALE_CODE = english.code;
/**
 * Priority ordered array of locales
 * @type {Locale[]}
 */

exports.DEFAULT_LOCALE_CODE = DEFAULT_LOCALE_CODE;
var ordered = [english, japanese, korean, chineseSimplified, chineseTraditional, german, spanish, french, italian, indonesian, malay, portuguese, russian, tagalog, thai, lao, vietnamese, arabic];
/**
 * All locales
 * @type {Object} keys are locale codes, values are Locale objects
 */

exports.ordered = ordered;
var locales = ordered.reduce(function (result, locale) {
  result[locale.code] = locale;
  return result;
}, {});
exports.locales = locales;
var _default = locales;
exports["default"] = _default;